module.exports = __webpack_public_path__ + "static/icons/icon-reef-7cc183a2e10fd4a19244995ec87bd78c.svg";